/* tslint:disable:max-line-length */

import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {
    HeaderAreaBox,
    ContractBodyArea,
    FirstContractPageDiv,
    ContractHeaderArea,
    NextContractPageDiv,
    ContractApplyTitle,
} from './NatAdminApplicatioPrintCommonStyle'
import {USER_ATTRIBUTE} from '../../../../../../CodeMaster'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {NatBikeParkingUseApplyDetail} from '../../../repository/NatGetBikeParkingUseApply'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'

interface Props {
    bikeParkingUseContractDocumentParam: NatBikeParkingUseApplyDetail
}

export const NatBikeParkingUseContractDocument: React.FC<Props> = props => {
    const {
        condominiumName,ridgeName, roomNumber, applicantFamilyName,
        applicantFirstName, useArea, useStartDate, userFamilyName,
        userFirstName, userAttribute, ownerFamilyName, ownerFirstName,
        bikeType, bikeName, bikeRegistrationNumber, engineSize
    } = props.bikeParkingUseContractDocumentParam

    const useStartYearMonthDay = getPrintDate(useStartDate)
    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`
    const userName = `${userFamilyName} ${userFirstName}`
    const ownerName = `${ownerFamilyName} ${ownerFirstName}`

    return (<>
        <FirstContractPageDiv>
            <ContractHeaderArea>
                <HeaderAreaBox>
                    <Box m={'auto'} mt={'10mm'}><ContractApplyTitle>バイク置場使用契約書</ContractApplyTitle></Box>
                </HeaderAreaBox>
            </ContractHeaderArea>
            <ContractBodyArea>
                <Box margin={'3mm 0mm 5mm 10mm'}>
                    {' ' + condominiumName}管理組合（以下「甲」という。）と
                    <Box>
                        <TextUnderline width={75}>{applicantRoom}</TextUnderline>号室組合員
                        <TextUnderline width={68}>{applicantName}</TextUnderline>
                    </Box>
                    <Box>
                        （以下「乙」という。）とは、甲が管理するバイク置場・ミニバイク置場（以下「バイク置場」という。）につき、バイク置場使用規則に基づき次のとおりバイク置場使用契約（以下「本契約」という。）を締結する。
                    </Box>
                </Box>
                <Box ml={'10mm'}>
                    <Box>
                        <ArticleTitle>第１条（駐輪区画）</ArticleTitle>
                        <ArticleContent>
                            乙が契約する駐輪区画は、次のとおりとする。
                            <Box ml={'6mm'} width={'105mm'}>
                                {renderApplicationDetail('駐輪区画',
                                    <TextUnderlineLeft width={70}>{useArea}</TextUnderlineLeft>)}
                            </Box>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第２条（使用者及び契約バイク）</ArticleTitle>
                        <ArticleContent>
                            <Box ml={'3mm'} width={'105mm'}>
                                <PrintApplicationDetailContainer>
                                    <Box>
                                        <Box component={'span'} mr={'5mm'}>一</Box>
                                        <Box component={'span'}>使用者 氏名</Box>
                                    </Box>
                                    <TextUnderlineLeft width={70}>{userName}</TextUnderlineLeft>
                                </PrintApplicationDetailContainer>
                                <Box ml={'8mm'}>（実際にバイク置場を使用する者の氏名）</Box>
                                <Box ml={'8mm'}>
                                    {USER_ATTRIBUTE.values().map((master, index) => {
                                        const check = (USER_ATTRIBUTE.codeToEnumConstants(userAttribute) === master) ? '☑' : '□'
                                        return (
                                            <Box component={'span'} mr={'3mm'} key={index}>{check}{master.label}</Box>
                                        )
                                    })}
                                </Box>
                            </Box>
                        </ArticleContent>
                        <ArticleContent>
                            <Box ml={'3mm'} width={'150mm'}>
                                <Box>
                                    <Box component={'span'} mr={'5mm'}>二</Box>
                                    <Box component={'span'}>バイクの明細（契約バイク）</Box>
                                </Box>
                                <Box ml={'2mm'}>
                                    {renderApplicationDetail('①　所有者',
                                        <TextUnderlineLeft width={117}>
                                            {ownerName}
                                        </TextUnderlineLeft>)
                                    }
                                    {renderApplicationDetail('②　種別',
                                        <TextUnderlineLeft width={117}>
                                            {bikeType}
                                        </TextUnderlineLeft>)
                                    }
                                    {renderApplicationDetail('③　車名',
                                        <TextUnderlineLeft width={117}>
                                            {bikeName}
                                        </TextUnderlineLeft>)
                                    }
                                    {renderApplicationDetail('④　標識登録番号',
                                        <TextUnderlineLeft width={117}>
                                            {bikeRegistrationNumber}
                                        </TextUnderlineLeft>)
                                    }
                                    {renderApplicationDetail('⑤　排気量',
                                        <TextUnderlineLeft width={117}>
                                            {engineSize + 'cc'}
                                        </TextUnderlineLeft>)
                                    }
                                </Box>
                            </Box>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第３条（使用目的）</ArticleTitle>
                        <ArticleContent>
                            <Indent>乙は、第１条記載の駐輪区画を、契約バイクの駐輪以外の目的に使用してはならない。</Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第４条（バイクの変更）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                乙は、契約バイク以外のバイクを駐輪する場合あるいは契約バイクを変更する場合には、書面をもって１週間前までに甲に通知しなければならない。ただし、使用者が乙以外の場合は、その者から甲に届け出させることができる。<br/>
                                <IndentAfterSecondLine>
                                    ２ 甲は、前項に掲げるバイクを指定された駐輪区画に駐輪することが不適切であると判断するときは、これを中止させることができる。
                                </IndentAfterSecondLine>
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第５条（契約期間）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                契約期間は、
                                <TextUnderlineLeft width={15}>
                                    {useStartYearMonthDay.year}
                                </TextUnderlineLeft>年
                                <TextUnderlineLeft width={8}>
                                    {useStartYearMonthDay.month}
                                </TextUnderlineLeft>月
                                <TextUnderlineLeft width={8}>
                                    {useStartYearMonthDay.day}
                                </TextUnderlineLeft>日から
                                <TextUnderlineLeft width={15}>　</TextUnderlineLeft>年
                                <TextUnderlineLeft width={8}>　</TextUnderlineLeft>月
                                <TextUnderlineLeft width={8}>　</TextUnderlineLeft>日
                                までとする。<br/>
                                <IndentAfterSecondLine>
                                    ２ 前項にかかわらず、バイク置場使用規則に基づき、甲が乙に明け渡しを請求した場合、契約期間は甲の通知からバイク置場使用規則に定める期間を経過する日の月末以内に終了するものとする。
                                </IndentAfterSecondLine>
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第６条（使用料）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                使用料は、月額 <TextUnderline width={15}>　</TextUnderline>円とする。乙は、毎月規約に定める管理費等の徴収日までに、使用料を支払うものとする。<br/>
                                ２ 前項にかかわらず、契約月の使用期間が１か月に満たない場合の対応は、バイク置場使用規則の定めによる。<br/>
                                ３ 乙は、その占有者にバイク置場を転貸する場合、第１項の使用料と同額にしなければならない。<br/>
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第７条（譲渡、転貸等の禁止）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                乙は、事由の如何を問わず、本契約に基づく権利を第三者に譲渡、転貸（乙がその占有者に転貸する場合を除く）並びに担保提供の権利の設定又は移転等の処分をしてはならない。
                            </Indent>
                        </ArticleContent>
                    </Box>
                </Box>
            </ContractBodyArea>
        </FirstContractPageDiv>
        <NextContractPageDiv>
            <ContractBodyArea>
                <Box ml={'10mm'} mt={'10mm'}>
                    <Box>
                        <ArticleTitle>第８条（甲の責任範囲）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                契約バイクの駐輪中若しくは入出庫中に、当該バイクに火災、故障、損傷、盗難等の損害が生じても、甲はその責を負わないものとする。
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第９条（乙等の責任範囲）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                乙又はその占有者若しくはそれらの同居人、使用人若しくはその他関係者（以下あわせて「乙等」という。）が、バイク置場の使用にあたって、バイク置場又はその附属施設及び駐輪中又は入出庫中の他のバイクに損害を与えた場合は、乙の責任において処理解決するものとする。<br/>
                                ２ 乙は、自己以外の乙等に、本契約の内容を遵守させなければならない。
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第１０条（解約の申し入れ）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                乙は、本契約を契約期間中に解約しようとするときは、書面をもってバイク置場使用規則に定める日時までに甲に通知しなければならない。
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第１１条（契約終了時の明渡し義務）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                契約期間の満了、中途解約又は解除により、本契約が終了したときは、乙はただちに契約バイクを搬出し、バイク置場を甲に明け渡さなければならない。
                            </Indent>
                        </ArticleContent>
                    </Box>
                    <Box>
                        <ArticleTitle>第１２条（契約の解除）</ArticleTitle>
                        <ArticleContent>
                            <Indent>
                                乙等が、バイク置場使用規則若しくは本契約に違反したときは、甲は乙に対し何等の通知又は催告を要しないで、ただちに本契約を解除できる。
                            </Indent>
                        </ArticleContent>
                    </Box>
                </Box>
            </ContractBodyArea>
            <Box mt={'5mm'} ml={'30mm'}>
                本契約を証するため、本書２通を作成し、甲乙双方記名押印のうえ、各自１通を保有する。
                <Box margin={'10mm 0 0 15mm'}>
                    <Box component={'span'} padding={'0 3mm 0 3mm'}/>年
                    <Box component={'span'} padding={'0 3mm 0 3mm'}/>月
                    <Box component={'span'} padding={'0 3mm 0 3mm'}/>日
                </Box>
                <Box margin={'10mm 0 0 40mm'}>
                    <Box>甲（管理組合）</Box>
                    <Box component={'span'} ml={'5mm'}>{condominiumName}管理組合</Box>
                    <Box mr={'5mm'} mt={'5mm'} textAlign={'right'}>㊞</Box>
                </Box>
                <Box margin={'15mm 0 0 40mm'}>
                    <Box>乙（組合員）</Box>
                    <Box display={'flex'}>
                        <Box ml={'20mm'}>号室</Box>
                        <Box ml={'5mm'}>氏名</Box>
                        <Box mr={'5mm'} ml={'auto'}>㊞</Box>
                    </Box>
                </Box>
            </Box>
        </NextContractPageDiv>
    </>)

    NatBikeParkingUseContractDocument.displayName = 'NatBikeParkingUseContractDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            {value}
        </PrintApplicationDetailContainer>
    )
}

const TextUnderline = styled.div<{ width: number }>`
  display: inline-block;
  border-bottom: 1px solid black;
  width: ${props => props.width}mm;
  text-align: center;
`

const TextUnderlineLeft = styled(TextUnderline)<{ width: number }>`
  margin-left: auto;
  text-align: left;
`

const ArticleTitle: StyledDiv = styled.div`
  font-weight: 700;
  margin-top: 3mm;
`

const ArticleContent: StyledDiv = styled.div`
  margin-left: 5mm;
`

const Indent: StyledDiv = styled.div`
  display: inline-block;
  text-indent: 1em;
  margin: 0;
`

const IndentAfterSecondLine = styled(Indent)`
  padding-left: 1em;
  text-indent: -1em;
`

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1mm;
`
